import React from "react";
import {
    Box,
    Grid,
    Card,
    CardMedia,
    CardContent,
    Typography
} from "@mui/material";

function IndiaLocation() {
    const locations = [
        {
            id: "hyderabad",
            title: "Hyderabad",
            image: "/images/buddastatue.jpg",
            address: (
                <>
                    Office 301, MSR Arcade, <br />
                    Patrika nagar, Madhapur, <br />
                    Hyderabad-500081.
                </>
            ),
            tel: "+91 9000316721",
            email: "info@vensyx.com",
            website: "www.vensyx.com"
        },
        {
            id: "vizag",
            title: "Vishakapatnam",
            image: "/images/vizag.jpg",
            address: (
                <>
                    7-110/1, Prasanthi Nagar, <br />
                    Pendurthy, Vishakapatnam-531173.
                </>
            ),
            tel: "+91 9000316726",
            email: "info@vensyx.com",
            website: "www.vensyx.com"
        }
    ];

    return (
        <Box sx={{ p: 3 }}>
            <Grid
                container
                spacing={3}
                justifyContent="center" // centers the cards
            >
                {locations.map((loc) => (
                    <Grid
                        item
                        key={loc.id}
                        xs={12} sm={6} md={4} // equal width at breakpoints
                        sx={{ display: "flex", justifyContent: "center" }}
                    >
                        <Card
                            sx={{
                                width: 300, // fixed equal width
                                borderRadius: 2,
                                boxShadow: 3,
                                bgcolor: "background.paper"
                            }}
                        >
                            <CardMedia
                                component="img"
                                height="200"
                                image={loc.image}
                                alt={loc.title}
                                sx={{ borderRadius: "10px 10px 0 0" }}
                            />
                            <CardContent>
                                <Typography variant="h5" gutterBottom>
                                    {loc.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    {loc.address}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Tel: {loc.tel}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Email: {loc.email}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Website: {loc.website}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default IndiaLocation;
